import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import Dropdown from '../Atoms/Dropdown';
import Input from '../Atoms/Input';

const fieldPropTypes = PropTypes.shape({
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  value: PropTypes.string,
});

const propTypes = exact({
  confirmEmailAddressPlaceholderText: PropTypes.string,
  emailAddressPlaceholderText: PropTypes.string,
  fieldset: PropTypes.shape({
    confirmEmail: fieldPropTypes.isRequired,
    email: fieldPropTypes.isRequired,
    firstName: fieldPropTypes.isRequired,
    surname: fieldPropTypes.isRequired,
    title: fieldPropTypes.isRequired,
  }).isRequired,
  fieldNamePrefix: PropTypes.string.isRequired,
  forenamePlaceholderText: PropTypes.string,
  handleFieldChange: PropTypes.func,
  surnamePlaceholderText: PropTypes.string,
  titleOptions: PropTypes.array.isRequired,
  titlePlaceholderText: PropTypes.string,
});

const defaultProps = {
  confirmEmailAddressPlaceholderText: 'Confirm Email Address',
  emailAddressPlaceholderText: 'Email Address',
  forenamePlaceholderText: 'First Name',
  handleFieldChange: () => false,
  surnamePlaceholderText: 'Surname',
  titlePlaceholderText: 'Title',
};

function MemberDetails(props) {
  const titleOptions = props.titleOptions.map((titleOption) => ({
    text: titleOption,
    value: titleOption,
  }));

  return (
    <div className="MemberDetails">
      <div className="MemberDetails_group">
        <div className="MemberDetails_item MemberDetails_item-1/3">
          <Dropdown
            fieldName={`${props.fieldNamePrefix}.title`}
            fieldValue={props.fieldset.title.value}
            handleChange={props.handleFieldChange}
            isInvalid={props.fieldset.title.isInvalid}
            isRequired={props.fieldset.title.isRequired}
            modifier="ghost"
            options={titleOptions}
            placeholderText={props.titlePlaceholderText}
          />
        </div>
        <div className="MemberDetails_item MemberDetails_item-1/3">
          <Input
            fieldName={`${props.fieldNamePrefix}.firstName`}
            fieldValue={props.fieldset.firstName.value}
            handleChange={props.handleFieldChange}
            inputType="text"
            isInvalid={props.fieldset.firstName.isInvalid}
            isRequired={props.fieldset.firstName.isRequired}
            modifier="ghost"
            placeholderText={props.forenamePlaceholderText}
          />
        </div>
        <div className="MemberDetails_item MemberDetails_item-1/3">
          <Input
            fieldName={`${props.fieldNamePrefix}.surname`}
            fieldValue={props.fieldset.surname.value}
            handleChange={props.handleFieldChange}
            inputType="text"
            isInvalid={props.fieldset.surname.isInvalid}
            isRequired={props.fieldset.surname.isRequired}
            modifier="ghost"
            placeholderText={props.surnamePlaceholderText}
          />
        </div>
      </div>
      <div className="MemberDetails_group">
        <div className="MemberDetails_item MemberDetails_item-1/3">
          <Input
            fieldName={`${props.fieldNamePrefix}.email`}
            fieldValue={props.fieldset.email.value}
            handleChange={props.handleFieldChange}
            inputType="email"
            isInvalid={props.fieldset.email.isInvalid}
            isRequired={props.fieldset.email.isRequired}
            modifier="ghost"
            placeholderText={props.emailAddressPlaceholderText}
          />
        </div>
      </div>
      <div className="MemberDetails_group">
        <div className="MemberDetails_item MemberDetails_item-1/3">
          <Input
            fieldName={`${props.fieldNamePrefix}.confirmEmail`}
            fieldValue={props.fieldset.confirmEmail.value}
            handleChange={props.handleFieldChange}
            inputType="email"
            isInvalid={props.fieldset.confirmEmail.isInvalid}
            isRequired={props.fieldset.confirmEmail.isRequired}
            modifier="ghost"
            placeholderText={props.confirmEmailAddressPlaceholderText}
          />
        </div>
      </div>
    </div>
  );
}

MemberDetails.propTypes = propTypes;
MemberDetails.defaultProps = defaultProps;

export default MemberDetails;
